/* eslint-disable @trello/assets-alongside-implementation */
/* eslint-disable @trello/export-matches-filename */
/* eslint-disable @trello/disallow-filenames */

import type { ActionSubjectIdType } from '@trello/atlassian-analytics';

// eslint-disable-next-line @trello/less-matches-component
import styles from './DiscoveryAdPowerUp.less';

import leftHandDark from 'resources/images/discovery-ads/left-hand-nav-dark.svg';
import leftHandLight from 'resources/images/discovery-ads/left-hand-nav-light.svg';

interface AdVariation {
  image_light: string;
  image_dark: string;
  content: string;
  href: string;
  css_container: string;
  dismiss_message: string;
}

export type AdLocation = 'powerup_directory' | 'powerup_menu';

export type TemplateCategory =
  | 'design'
  | 'marketing'
  | 'project-management'
  | undefined;

interface FeedbackOption {
  value: ActionSubjectIdType;
  name: string;
}

// value will be name of analytics button event, pending DS approval
export const FEEDBACK_OPTIONS: FeedbackOption[] = [
  {
    value: 'feedbackAlreadyUseButton',
    name: 'use-jwm-already',
  },
  {
    value: 'feedbackUseOtherToolsButton',
    name: 'use-other-pm-tools',
  },
  {
    value: 'feedbackWontBenefitButton',
    name: 'wont-benefit',
  },
  {
    value: 'feedbackWrongPersonButton',
    name: 'not-right-person',
  },
];

export const AD_VARIATIONS: Record<AdLocation, AdVariation> = {
  powerup_directory: {
    image_light: leftHandLight,
    image_dark: leftHandDark,
    content: 'left-hand-content',
    href: 'https://www.atlassian.com/software/jira/work-management?utm_source=in-product-banner&utm_medium=inapp&utm_campaign=P:jira-work-management*O:trello*F:cross-sell*C:hp*W:trello-jwm-non-co-mau*H:fy24*I:1p-ad-left-hand-nav*E:cloud*X:expand*',
    css_container: styles.powerupDirectoryContainer,
    dismiss_message: '1p-discovery-ad-powerup-directory',
  },
  powerup_menu: {
    image_light: leftHandLight,
    image_dark: leftHandDark,
    content: 'left-hand-content',
    href: 'https://www.atlassian.com/software/jira/work-management?utm_source=in-product-banner&utm_medium=inapp&utm_campaign=P:jira-work-management*O:trello*F:cross-sell*C:hp*W:trello-jwm-non-co-mau*H:fy24*I:1p-ad-left-hand-nav*E:cloud*X:expand*',
    css_container: styles.powerupMenuContainer,
    dismiss_message: '1p-discovery-ad-powerup-menu',
  },
};
